/*
 * Built with Common Launchpad 4.0.2
 */

import $ from 'jquery';
import Cookies from 'js-cookie';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class FocusAreaCards {
    constructor() {}

    init() {
        this.bindEvents();
        this.keyframes = [
            { opacity: 1, easing: 'ease-in-out' },
            { opacity: 0, easing: 'ease-in-out' },
            { opacity: 1, easing: 'ease-in-out' }
        ];
        this.options = {
            duration: 750,
            iterations: 1,
            fill: 'forwards'
        };
    }

    bindEvents() {
        $(window).on('load', () => {
            $('.js-click-fade').hover((e) => {
                let cardSelected = $(e.currentTarget).data('card-id');
                let container = $('.focus-area-cards-values-wrapper-value');
                let value = $(e.currentTarget).data('card-value');
                let title = $(e.currentTarget).data('card-title');
                $('.focus-area-cards-priorities-wrapper-priority.hovered').removeClass('hovered');
                if ($(container.length > 0)) {
                    //container[0].animate(this.keyframes, this.options);
                    $('.focus-area-cards-values-wrapper-value-number')[0].innerHTML = value;
                    $('.focus-area-cards-values-wrapper-value-title')[0].innerHTML = title;
                    this.fitTextToContainer(container, $('.focus-area-cards-values-wrapper-value-number')[0]);                    
                }
                if ($(`[data-card-id='${cardSelected}']`)) {
                    $('.focus-area-cards-priorities-wrapper-priority.active-value').removeClass('active-value');
                    $(`[data-card-id='${cardSelected}']`).removeClass('active-value');
                }
                //$('#musicinfo').fadeToggle();
                // $('.focus-area-cards-values-value:not(.hidden-value)')
            });

            $('.js-click-fade').click((e) => {
                let cardUrl = e.currentTarget.getAttribute('data-card-url');
                if (cardUrl) {
                    window.location.href = cardUrl;
                }
            });

            const boxes = $('.focus-area-cards-priorities-wrapper-priority');
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            $(entry.target).trigger('mouseenter');
                            setTimeout(() => {
                                $(entry.target).addClass('hovered');
                            }, 100);
                        } else {
                            $(entry.target).trigger('mouseleave');
                            setTimeout(() => {
                                $(entry.target).removeClass('hovered');
                            }, 100);
                        }
                    });
                },
                {
                    root: null,
                    threshold: 0,
                    rootMargin: '-50% 0px -50% 0px',
                }
            );
            
            boxes.each((index, box) => observer.observe(box));
        });
    }

    fitTextToContainer(container, element) {
        let fontSize = 260;
        element.style.fontSize = `${fontSize}px`;
        element.style.lineHeight = `${fontSize}px`;

        if (element && container.length) {
            while (element.scrollWidth > container[0].clientWidth && (fontSize > 5)) {
                fontSize -= 3;
                element.style.fontSize = `${fontSize}px`;
                element.style.lineHeight = `${fontSize}px`;
            }
        }
    }

    closeBanner(e) {

    }
}

export default FocusAreaCards;

$(() => {
	const focusAreaCards = new FocusAreaCards();
	focusAreaCards.init();
});